import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import HomeIcon from '@mui/icons-material/Home';
import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import useMessagingHandoff from '../hooks/useMessagingHandoff';
import { OnlyFansSubscriber } from '../hooks/useSubscriber';
import { ServiceActions, SettingsContext } from '../store/SettingsContext';
import { getServiceStatusColor } from '../utils/common';
import { isMessagingBetaSubscriber } from '../utils/messagingBeta';

type Props = {
    subscriber: OnlyFansSubscriber;
    service: string;
    handleDrawerToggle: (event: React.KeyboardEvent | React.MouseEvent) => void;
};

const HeaderSideMenuSubscriberServiceActions = (props: Props) => {
    const { subscriber, service, handleDrawerToggle } = props;
    const settingsContext = useContext(SettingsContext);
    const { goToMessaging } = useMessagingHandoff();
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    const serviceHasActions: boolean =
        settingsContext.services[service].actions && settingsContext.services[service].actions!.length > 0 ? true : false;

    return (
        <>
            <ListItemButton
                onClick={() => {
                    setMenuOpen(!menuOpen);
                }}
            >
                <ListItemIcon
                    sx={{
                        minWidth: '32px',
                    }}
                >
                    {settingsContext.services[settingsContext.services[service].serviceNameKey || service].icon(
                        settingsContext.services[settingsContext.services[service].serviceNameKey || service].alwaysActive
                            ? 'success'
                            : getServiceStatusColor(
                                  subscriber,
                                  settingsContext.services[service].serviceNameKey || service,
                                  settingsContext.services[settingsContext.services[service].serviceNameKey || service].alwaysActive,
                              ),
                    )}
                </ListItemIcon>
                <ListItemText primary={settingsContext.services[service].name} />
                {serviceHasActions && (menuOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            {serviceHasActions && (
                <Collapse in={menuOpen} timeout="auto" unmountOnExit={true}>
                    <List dense disablePadding sx={{ pl: 2 }}>
                        <ListItemButton
                            component={Link}
                            to={`/subscribers/${subscriber._id}/${settingsContext.services[service].homeUrl}`}
                            onClick={handleDrawerToggle}
                            onKeyDown={handleDrawerToggle}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: '32px',
                                }}
                            >
                                <HomeIcon />
                            </ListItemIcon>
                            <ListItemText primary="Overview" />
                        </ListItemButton>
                    </List>
                    <List dense disablePadding sx={{ pl: 2 }}>
                        {settingsContext.services[service].actions &&
                            settingsContext.services[service]
                                .actions!.filter(
                                    (action: ServiceActions) =>
                                        action.type === 'category' ||
                                        (action.type === 'action' &&
                                            action.visible !== false &&
                                            // Messaging beta: only allowlisted subscribers see the handoff action.
                                            (!action.handoff || isMessagingBetaSubscriber(subscriber._id))),
                                )
                                .map((action: ServiceActions, index: number) => (
                                    <React.Fragment key={index}>
                                        {action.type === 'category' && (
                                            <ListItem
                                                disablePadding
                                                sx={{
                                                    pl: 2,
                                                    '&:hover': {
                                                        background: 'transparent',
                                                    },
                                                }}
                                            >
                                                <ListItemText
                                                    primary={action.title}
                                                    primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                                                />
                                            </ListItem>
                                        )}
                                        {action.type === 'action' && action.handoff && (
                                            <ListItemButton
                                                onClick={event => {
                                                    handleDrawerToggle(event);
                                                    goToMessaging();
                                                }}
                                                key={index}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: '32px',
                                                    }}
                                                >
                                                    {action.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={action.title} />
                                            </ListItemButton>
                                        )}
                                        {action.type === 'action' &&
                                            !action.handoff &&
                                            (action.external ? (
                                                <ListItemButton
                                                    component="a"
                                                    href={action.url(subscriber._id!)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={handleDrawerToggle}
                                                    onKeyDown={handleDrawerToggle}
                                                    key={index}
                                                >
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: '32px',
                                                        }}
                                                    >
                                                        {action.icon}
                                                    </ListItemIcon>
                                                    <ListItemText primary={action.title} />
                                                </ListItemButton>
                                            ) : (
                                                <ListItemButton
                                                    component={Link}
                                                    to={action.url(subscriber._id!)}
                                                    onClick={handleDrawerToggle}
                                                    onKeyDown={handleDrawerToggle}
                                                    key={index}
                                                >
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: '32px',
                                                        }}
                                                    >
                                                        {action.icon}
                                                    </ListItemIcon>
                                                    <ListItemText primary={action.title} />
                                                </ListItemButton>
                                            ))}
                                    </React.Fragment>
                                ))}
                    </List>
                </Collapse>
            )}
        </>
    );
};

export default HeaderSideMenuSubscriberServiceActions;
